"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ControlsFormCheckboxInput = void 0;
const DOM_1 = require("../../../../../public/js/utils/DOM");
var ControlsFormCheckboxInput;
(function (ControlsFormCheckboxInput) {
    class Config {
        static inputContainerClass = "CheckboxInput";
        static dataFloatWidthName = "float";
    }
    ControlsFormCheckboxInput.Config = Config;
    class Control {
        static initialize(container) {
            const inputs = DOM_1.DOM.Parser.getHtmlElements(Config.inputContainerClass, container, true);
            for (let i = 0; i < inputs.length; i++) {
                this.initializeElement(inputs[i]);
            }
        }
        static initializeElement(element) {
            if (DOM_1.DOM.Parser.getDataByNameFromElement(Config.dataFloatWidthName, element) === 'yes') {
                DOM_1.DOM.Parser.getParentElement(element).classList.replace('m6', 'm12');
                DOM_1.DOM.Parser.getParentElement(element).classList.replace('l4', 'l6');
            }
        }
    }
    ControlsFormCheckboxInput.Control = Control;
})(ControlsFormCheckboxInput || (exports.ControlsFormCheckboxInput = ControlsFormCheckboxInput = {}));
